export default __webpack_public_path__ + "static/media/header-xs-2x.fd55bf96.png";